import { render } from "./PopupMessage.vue?vue&type=template&id=2204842b&scoped=true"
import script from "./PopupMessage.vue?vue&type=script&lang=js"
export * from "./PopupMessage.vue?vue&type=script&lang=js"

import "./PopupMessage.vue?vue&type=style&index=0&id=2204842b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2204842b"]])

export default __exports__